import React from 'react'
import { calculateHoursAndMinutes } from '../../utils/DateTimeFormat';
import "./index.scss"

const MovieCard = ({ film, filmIndex, handleMovieClick, selectedFilm }) => {
    return (
        <div key={filmIndex} className={`movies-list col-3 ${selectedFilm?.id === film.id ? 'is-selected' : ''}`}>
            <a onClick={() => handleMovieClick(film)} title={film.title}>
                <div>
                    {film.images.length > 0
                        ? film.images
                            .filter(img => img.code == 'x250y350')
                            .map(({ imageurl }) => {
                                return (
                                    <div className="img-blk">
                                        <img src={imageurl ? imageurl : ''} className="img-fluid" alt={film.title} />
                                    </div>
                                );
                            })
                        : null}
                    <aside className="cont-sec">
                        <h4>{film.title}</h4>
                        <p>
                            {film.rating && <span>{film.rating}</span>}
                            {film.rating && film.runtime && <>&nbsp;-&nbsp;</>}
                            {film.runtime && <span>{calculateHoursAndMinutes(film.runtime)}</span>}
                        </p>
                        <p className="cont-geners-sec">
                            {/* {film.runtime && film.genres.length > 0 && <>&nbsp;-&nbsp;</>} */}
                            {film.genres.map((genresData, index) => {
                                return (
                                    <span>
                                        {genresData.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())} {film.genres.length - 1 == index ? '' : '/'}{' '}
                                    </span>
                                );
                            })}
                        </p>
                    </aside>
                    <div className="mov-det">
                        {film.emblems.length > 0 ? (
                            <aside className="ad-book">
                                <span>{film.emblems[0]}</span>
                            </aside>
                        ) : null}
                    </div>
                </div>
            </a>
        </div>
    )
}

export default MovieCard
